__turbopack_context__.v({
  "categoryPageList": "FooterPageList-module-scss-module__DEO1ua__categoryPageList",
  "categoryTitle": "FooterPageList-module-scss-module__DEO1ua__categoryTitle",
  "footerPageList": "FooterPageList-module-scss-module__DEO1ua__footerPageList",
});
